import CONST_STYLE from '../../constants/styles'

const styles = {
  caption : {
    color : CONST_STYLE.colors.CAPTION,
    fontSize : '12px',
    LetterSpacing : '0.4px'
  },
  bold : {
    fontWeight : '700',
    fontSize : '16px',
  }
}

export default styles;